import { Component } from '@angular/core';
import { MedrecordIcon } from '../../base/medrecord-icon';

@Component({
  selector: 'medrecord-svg-device',
  templateUrl: './device.component.svg',
})
export class DeviceComponent extends MedrecordIcon {
  viewHeight = 18;
  viewWidth = 18;
}
